import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerStack: {
            gap: remCalc(24),
        },
        addressTypeButtonGroup: {
            flexDirection: 'row',
            gap: remCalc(8),
        },
        addressTypeButton: {
            '&[aria-pressed="true"]': {
                backgroundColor: 'button.background.primary-default !important',
                cursor: 'default',
            },
        },
        radioCardGroupStack: {
            gap: remCalc(8),
        },
        homeDeliveryStack: {
            gap: remCalc(24),
        },
        addAddressAndSubmitButton: {
            width: ['100%', '100%', '100%', remCalc(332)],
            marginBottom: remCalc(0),
        },
    },
}
